import MainHeader from '../../layouts/PublicHeader';
import Advertise from '../LandingPage/Advertise';
import ProfessionalSlogan from '../LandingPage/ProfessionalSlogan';

type Props = {};

const Test = (_props: Props) => {
  return (
    <div>
      <Advertise />
      <MainHeader />
      <ProfessionalSlogan />
      {/* <Footer /> */}
    </div>
  );
};

export default Test;
